export interface VehicleTypeActionTypes {
  type: VehicleTypeActions;
  payload?: any;
}

export enum VehicleTypeActions {
  CREATE_VEHICLE_TYPE = "CREATE_VEHICLE_TYPE",
  GET_VEHICLE_TYPE_LIST = "GET_VEHICLE_TYPE_LIST",
  SET_VEHICLE_TYPE_LIST = "SET_VEHICLE_TYPE_LIST",
  SET_VEHICLE_TYPE_LIST_PAGE_COUNT = "SET_VEHICLE_TYPE_LIST_PAGE_COUNT",
  GET_VEHICLE_TYPE_DATA_BY_ID = "GET_VEHICLE_TYPE_DATA_BY_ID",
  SET_VEHICLE_TYPE_DATA_BY_ID = "SET_VEHICLE_TYPE_DATA_BY_ID",
  EDIT_VEHICLE_TYPE_DATA_BY_ID = "EDIT_VEHICLE_TYPE_DATA_BY_ID",
}
